import { Dist } from "./Dist"
import Graphics, { updateCameraToScene } from "./Graphics"
import {WallType, buckets} from "./internalModules"
import {WallTypeRibbon} from "./internalModules"

export class WallTypeCurtain extends WallTypeRibbon {

  constructor (height: Dist, width: Dist, windowToWallRatio: number) {
    super(height, width, windowToWallRatio)
    this.className = 'WallTypeCurtain'
    this.glazedHeight = new Dist( windowToWallRatio * height.ft, 0)
    this.solidHeight = new Dist( (height.ft - windowToWallRatio * height.ft), 0) //to be set with wwr
    this.wallTypeGlazed = new WallType(this.glazedHeight, this.width)
    this.wallTypeSolid = new WallType(this.solidHeight, this.width)
    this._wwr = windowToWallRatio
  }

  //method to update module height
  updateHeight(ht: Dist) {
    this.height = ht
    this.glazedHeight = new Dist( this.wwr * this.height.ft, 0)
    this.solidHeight = new Dist( (this.height.ft - this.glazedHeight.ft), 0)
    this.regenSubtypes()
    this.calculateGwpSF()
    this.regenGeometry()
  }

  regenGeometry() {
    Graphics.clearSceneMeshes(this.scene)
    if(this.layerCount < 1){
      return
    }
    // geometry for spandrel solid subtype
    let mesh = this.wallTypeSolid.getMeshCurtainWall(0, this._explodeAmount)[0]
    mesh.translateY( -this.height.ft / 2 + this.wallTypeSolid.height.ft / 2 )
    this.scene.add(mesh)

    // geometry for glazed subtype
    mesh = this.wallTypeGlazed.getMeshCurtainWall(0, this._explodeAmount)[0]
    mesh.translateY( this.height.ft / 2 - this.wallTypeGlazed.height.ft / 2 )
    this.scene.add(mesh)
    this.colorMeshes()
    updateCameraToScene(this.camera, this.scene, this.orbitControls)
  }

}